export default __webpack_public_path__ + "4d85cca6c9d1d67d11c7b3dfffcb847a.svg";